var App = App || {};

App.DetailMasthead = (function ($) {
    'use strict';

    function init() {
        //prevent text content from overlapping bottom white curve
        var adjustableMastheads = $(".widget.widget-masthead-detail.has-cards:not(.has-image)");
        if (adjustableMastheads) {
            adjustableMastheads.each(function () {
                var contentWrapper = $(this).find(".masthead-detail")

                updateMastheadPadding(contentWrapper);

                var resizeTimer;
                $(window).resize(function () {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        updateMastheadPadding(contentWrapper);
                    }, 200); //debounce interval
                });
            });
        }
    }

    function updateMastheadPadding(contentWrapper) {
        var textContent = contentWrapper.find(".masthead-content")
        var cardsWrapper = contentWrapper.find(".masthead-cards-wrapper");

        if (textContent.outerHeight() > cardsWrapper.outerHeight() - 150) {
            contentWrapper.addClass("pad-bottom");
        } else {
            contentWrapper.removeClass("pad-bottom");
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.DetailMasthead.init();
});